"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdResponseAssetsToJSON = exports.AdResponseAssetsFromJSONTyped = exports.AdResponseAssetsFromJSON = exports.instanceOfAdResponseAssets = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AdResponseAssets interface.
 */
function instanceOfAdResponseAssets(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdResponseAssets = instanceOfAdResponseAssets;
function AdResponseAssetsFromJSON(json) {
    return AdResponseAssetsFromJSONTyped(json, false);
}
exports.AdResponseAssetsFromJSON = AdResponseAssetsFromJSON;
function AdResponseAssetsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'assetId': !(0, runtime_1.exists)(json, 'asset_id') ? undefined : json['asset_id'],
        'companionAssetId': !(0, runtime_1.exists)(json, 'companion_asset_id') ? undefined : json['companion_asset_id'],
        'logoAssetId': !(0, runtime_1.exists)(json, 'logo_asset_id') ? undefined : json['logo_asset_id'],
        'canvasAssetId': !(0, runtime_1.exists)(json, 'canvas_asset_id') ? undefined : json['canvas_asset_id'],
    };
}
exports.AdResponseAssetsFromJSONTyped = AdResponseAssetsFromJSONTyped;
function AdResponseAssetsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'asset_id': value.assetId,
        'companion_asset_id': value.companionAssetId,
        'logo_asset_id': value.logoAssetId,
        'canvas_asset_id': value.canvasAssetId,
    };
}
exports.AdResponseAssetsToJSON = AdResponseAssetsToJSON;
